import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { ResidencyPermitCrumbs } from 'front-office/constants/residency-permit-crumbs';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from 'front-office/components/residency-permit/actions-list';
import { __PERSON_API_URL__ } from 'shell/constants/environment';

const ResidencyPermitListPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={ResidencyPermitCrumbs} base="sportello" />
      <PersonSearch
        pathname="/sportello/rilascioPDS/modifica"
        action={ActionsList}
        url={`${__PERSON_API_URL__}/ricerca-persona/rilascio-permesso-di-soggiorno`}
        addedTitle="- Registrazione Permesso di soggiorno"
      />
    </Fragment>
  );
};

ResidencyPermitListPage.displayName = 'Document - residency permit page';

export default ResidencyPermitListPage;
